export default __webpack_public_path__ + "static/media/chemical_dna.0c901f33.png";